// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2Dzip","ranges":"BmiRanges_ranges__1VSuZ"};